import './src/styles/tokens.css';
import './src/styles/global.css';

export const onRouteUpdate = ({ location }: { location: Location }) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search + location.hash,
      ...(process.env.GATSBY_APP_ID && { app_id: process.env.GATSBY_APP_ID }),
    });
  }
};
